import React, { useEffect, useRef, useState } from 'react';

function Scrollspy({ introId, introLabel, items }) {
	const navRef = useRef(null);
	const [activeId, setActiveId] = useState(introId);

	useEffect(() => {
		const navElement = navRef.current;
		const updateActiveLink = () => {
			const ids = [introId, ...items.map((item) => item.id)];
			let currentId = introId;
			ids.forEach((id) => {
				const section = document.getElementById(id);
				if (section && section.getBoundingClientRect().top <= 160) currentId = id;
			});
			if (window.scrollY + window.innerHeight >= document.documentElement.scrollHeight - 10) currentId = ids[ids.length - 1];
			setActiveId(currentId);
		};
		const handleClick = (event) => {
			const link = event.target.closest('a[data-scrollspy-target]');
			if (!link) return;
			event.preventDefault();
			const target = document.getElementById(link.dataset.scrollspyTarget);
			if (!target) return;
			window.scrollTo({ top: window.scrollY + target.getBoundingClientRect().top - 80, behavior: 'smooth' });
			window.history.replaceState(null, '', `#${target.id}`);
			setActiveId(target.id);
		};

		window.addEventListener('scroll', updateActiveLink, { passive: true });
		navElement?.addEventListener('click', handleClick);
		updateActiveLink();
		return () => {
			window.removeEventListener('scroll', updateActiveLink);
			navElement?.removeEventListener('click', handleClick);
		};
	}, [introId, items]);

	return (
		<nav ref={navRef} data-init="scrollspy" className="navbar navbar-sticky navbar-sticky-start d-none d-xl-block py-4 h-100">
			<nav className="nav">
				<a className={`nav-link ${activeId === introId ? 'active' : ''}`} href={`#${introId}`} data-toggle="scroll-to" data-scrollspy-target={introId}>{introLabel}</a>
				{items.map((item) => <a className={`nav-link ${activeId === item.id ? 'active' : ''}`} href={`#${item.id}`} data-toggle="scroll-to" data-scrollspy-target={item.id} key={item.id}> - {item.label}</a>)}
			</nav>
		</nav>
	);
}

export default Scrollspy;
